export const BLOOD_PRESSURE_MONITOR_SNOMED = '135840009'
export const OTOSCOPE_SNOMED = '470067005'
export const OXIMETER_SNOMED = '462877003'
export const STETHOSCOPE_SNOMED = '468627005'
export const THERMOMETER_SNOMED = '448735006'
export const DERMATOSCOPE_SNOMED = '468265006'
